export const GoogleMapApiConfig = 'AIzaSyCV1RzDnVdBcVjyWO0QWxhyfzYw5XKY4dw';